export const SearchTypeFileAspect = 22 as const;
export type TSearchTypeFileAspect = typeof SearchTypeFileAspect;

/** elementSubType1 */
export enum FileAspectType {
	ORIENTATION = 0,
	/** seconds */
	DURATION = 1,
	WIDTH = 2,
	HEIGHT = 3,
}

/** elementSubType2 */
export enum FileAspectSubType {
	APPROXIMATELY = 0,
	GREATER_THAN = 1,
	LESS_THAN = 2,
	EQUAL_TO = 3,
}

/** elementValue1 if `ORIENTATION` */
export enum FileAspectOrientationValue {
	PORTRAIT = 1,
	LANDSCAPE = 2,
}
